import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './get-document-list.actions';
import { GetDocumentListState } from './get-document-list.state';

/**
 * getDocumentList initial state
 */
export const getDocumentListInitialState: GetDocumentListState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for GetDocumentList Store
 */
export const getDocumentListReducerFeatures: ReducerTypes<GetDocumentListState, ActionCreator[]>[] = [
  on(actions.setGetDocumentList, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateGetDocumentList, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetGetDocumentList, () => getDocumentListInitialState),

  on(actions.cancelGetDocumentListRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failGetDocumentList, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setGetDocumentListFromApi, actions.updateGetDocumentListFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * GetDocumentList Store reducer
 */
export const getDocumentListReducer = createReducer(getDocumentListInitialState, ...getDocumentListReducerFeatures);
